import React, { useEffect, useState } from "react";
import { graphql, Link } from "gatsby";
import Header from "../../components/Layout/BlogLayout/Header";
import BlogLayout from "../../components/Layout/BlogLayout/SideBlog2";
import Footer from "../../components/Layout/BlogLayout/Footer";
import Seo from "../../components/Seo/seo";
import FooterData from "../blog/FooterData";
import Tracks from "../../components/Layout/BlogLayout/Tracks/CourseTracks";
import AuthorCard from "../../components/Layout/BlogLayout/AuthorCard";
import "../blog/styling-text";
import PageScrollProgressBar from "react-page-scroll-progress-bar";
import "../../components/Layout/BlogLayout/appBlog.scss";
import { TableOfContents } from "../../components/Layout/BlogLayout/TableOfContents";

import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Card from "../../components/Layout/BlogLayout/Card";
import Popup from "../../components/Layout/BlogLayout/BlogsForm";
import UpcommingEvent from "../../components/KFLiveSeries/RegistrationSection/Card";
import { Share } from "../../components/Layout/BlogLayout/Share";
import LeadActivityTracker from "../../components/LeadActivityTracker";
import { useMediaQuery } from "@mui/material";

const BlogPostPage = ({ data, location }) => {
  const post = data.allWpPost.edges[0].node;
  const author = post.author.node.name;
  const category = post.acf.category;
  const publishDate = post.date;
  const readTime = post.readingTime;
  const title = post.title;
  const toc = post.toc.items;
  const link = location.href;
  const description = post.acf.description;
  const utmLink = post.acf.utmlink;
  const liveMediaImg = post.acf.sidebarBanner?.mediaItemUrl;
  const ksLiveUtm = post.acf.ksLiveUtm;
  const [currentIndex, setCurrentIndex] = useState(0);
  const FtCta = post.acf.mlpFtCardCarousel;
  const ETCta = post.acf.mlpEtCardCarousel;
  const PTCta = post.acf.mlpPtCardCarousel;
  const CSMCta = post.acf.cslpCardCarousel;
  const PGPCta = post.acf.pgpSalesCarousel;
  const programName = post.acf.programName;
  const opengraph = post.acf.opengraph?.sourceUrl;
  const varun = post.acf.varun;
  const eshu = post.acf.eshu;
  const nishtha = post.acf.nishthajain;

  let authorData = varun;

  if (author.toLowerCase().includes("eshu")) {
    authorData = eshu;
  } else if (author.toLowerCase().includes("nishtha")) {
    authorData = nishtha;
  }

  const isSmallScreen = useMediaQuery("(max-width:800px)");

  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const images = document.querySelectorAll(".carouselImg");
    const carousel = document.getElementById("carousel");
    const nextBtn = document.getElementById("nextBtn");
    const prevBtn = document.getElementById("prevBtn");

    const handleNextClick = () => {
      let tempVal = window.innerWidth < 600 ? 1 : 2;

      if (currentIndex < images.length - tempVal) {
        setCurrentIndex((prevIndex) => prevIndex + 1);
        carousel.style.transform = `translateX(-${(currentIndex + 1) * 300}px)`;
      }
    };

   

    const handlePrevClick = () => {
      if (currentIndex > 0) {
        setCurrentIndex((prevIndex) => prevIndex - 1);
        carousel.style.transform = `translateX(-${(currentIndex - 1) * 300}px)`;
      }
    };

    if (nextBtn && prevBtn) {
      nextBtn.addEventListener("click", handleNextClick);
      prevBtn.addEventListener("click", handlePrevClick);

      // Clean up event listeners on unmount
      return () => {
        nextBtn.removeEventListener("click", handleNextClick);
        prevBtn.removeEventListener("click", handlePrevClick);
      };
    }
  }, [currentIndex]);

  function truncateText(text, maxWords) {
    // Split the input text into words
    const words = text.split(" ");

    // Check if the text has more words than the maximum allowed
    if (words.length > maxWords) {
      // Slice the array to get the first maxWords words, then join them with spaces
      return words.slice(0, maxWords).join(" ") + "...";
    }

    // If the text has fewer or equal words than the maximum allowed, return it as is
    return text;
  }

  return (
    <React.Fragment>
      <Seo
        title={title}
        description={description ?? ""}
        url={"https://www.kraftshala.com" + "/blog/" + post.slug + "/"}
        image={opengraph}
      />
      <div className="navigation">
        <Header />
      </div>
      <PageScrollProgressBar
        color="#F1AE13"
        height="6px"
        class="scrollProgressBar"
        top="89px"
      />
      <div className="bottomBar">
        <button onClick={() => setIsOpen(true)} className="blogs-fixed-btn">
          Start My Marketing Career Today
        </button>
      </div>

      <div className="things-container">
        <BlogLayout
          toc={toc}
          liveMediaImg={liveMediaImg}
          ksLiveUtm={ksLiveUtm}
          link={utmLink}
          course={programName ?? "mlp"}
          isSmallScreen={isSmallScreen}
        >
          <div className="blog-wrapper-new">
            <div className="navigation-bar blog-nav">
              <Link to="/blog/">Blog</Link>{" "}
              <img src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m1ypfhbp.png" />{" "}
              <span>{truncateText(title, 4)}</span>
            </div>
            <h1 id="main-blog-page-header">{title}</h1>

            {author && category && publishDate && readTime && (
              <div className="author-category-blog">
                <a
                  className="a-c-link"
                  href={`/author/${author.replace(" ",'-').toLowerCase()}/`}
                  target="_blank"
                >
                  {author}
                </a> in
                <span>
                  <Link to="/blog/">
                    <u> {category}</u>{" "}
                  </Link>{" "}
                </span>{" "}
                <span className="icon-text" style={{ margin: "0 10px" }}>
                  <CalendarMonthIcon
                    fontSize="small"
                    sx={{ transform: "translateY(4px)" }}
                  />{" "}
                  {publishDate?.split(",")[0]}
                </span>{" "}
                {"  "}
                <span className="icon-text">
                  <AccessTimeFilledIcon
                    fontSize="small"
                    sx={{ transform: "translateY(5px)", marginRight: "2px" }}
                  />
                  {readTime} min
                </span>
              </div>
            )}
            <div className="pc-none">
              <hr className="mt-1" />
              <TableOfContents toc={toc} />
            </div>
            <div
              id={post.id}
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </div>
          {/* sidebars related courses */}
          <div className="shareArea pc-none">
            <hr />
            <Share link={link} />
            <hr className="mb-1" />
          </div>

          <div className="sidebar pc-none">
            <Card
              title="How to Build a Marketing CV That Recruiters Shortlist"
              course={programName ?? "mlp"}
              placement={isSmallScreen ? "End of blog - M" : "Sidebar - D"}
            />
            {/* <Sidebar3 /> */}
            <div className="sideBarUpcommingEvent">
              <UpcommingEvent
                liveMediaImg={liveMediaImg}
                ksLiveUtm={ksLiveUtm}
              />
            </div>
          </div>
          <AuthorCard author={authorData} />
          <Tracks
            FtCta={FtCta}
            ETCta={ETCta}
            PTCta={PTCta}
            slug={post.slug}
            CSMCta={CSMCta}
            PGPCta={PGPCta}
          />
          <FooterData category={category} title={title} />
        </BlogLayout>
      </div>
      <Footer />
      <Popup
        isOpen={isOpen}
        isLoading={false}
        handleClose={handleClose}
        course={programName ?? "mlp"}
        placement={isOpen && "Sticky Pop up - M"}
      />
      <LeadActivityTracker />
    </React.Fragment>
  );
};

export const query = graphql`
  query($slug: String) {
    allWpPost(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          title
          content
          slug
          toc {
            items {
              url
              title
              depth
            }
          }
          date(formatString: "MMM DD, YYYY ")
          author {
            node {
              name
            }
          }
          categories {
            nodes {
              name
            }
          }
          readingTime
          id
          acf {
            cslpCardCarousel
            pgpSalesCarousel
            mlpPtCardCarousel
            mlpFtCardCarousel
            mlpEtCardCarousel
            ksLiveUtm
            description
            utmlink
            showInCarousal
            category
            stickyCtaBarUtmLink
            programName
            varun
            nishthajain
            eshu
            opengraph {
              sourceUrl
            }
            sidebarBanner {
              mediaItemUrl
            }
          }
        }
      }
    }
  }
`;

export default BlogPostPage;
